export const PERFIS_CONHECIDOS = [
  'conselheiro',
  'sindico',
  'porteiro',
  'zelador',
  'morador',
  'proprietario',
  'agua-mineral'
];


// WEBPACK FOOTER //
// ./src/modules/auth/constants.js